import React from 'react';
import styles from './LoadingIcon.scss';

export function LoadingIcon() {
  return (
    <div className="LoadingIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="12px"
        width="56px"
        x="0px"
        y="0px"
        viewBox="0 0 1 100"
        xmlSpace="preserve"
        data-testid="loadingIcon"
      >
        <circle className="LoadingIcon__circle" cx="-140" cy="50" r="32" />
        <circle className="LoadingIcon__circle" cx="0" cy="50" r="32" />
        <circle className="LoadingIcon__circle" cx="140" cy="50" r="32" />
      </svg>
    </div>
  );
}
